/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface PostFleetsFleetIdMembersNotFound
 */
export interface PostFleetsFleetIdMembersNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof PostFleetsFleetIdMembersNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the PostFleetsFleetIdMembersNotFound interface.
 */
export function instanceOfPostFleetsFleetIdMembersNotFound(value: object): value is PostFleetsFleetIdMembersNotFound {
    return true;
}

export function PostFleetsFleetIdMembersNotFoundFromJSON(json: any): PostFleetsFleetIdMembersNotFound {
    return PostFleetsFleetIdMembersNotFoundFromJSONTyped(json, false);
}

export function PostFleetsFleetIdMembersNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostFleetsFleetIdMembersNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function PostFleetsFleetIdMembersNotFoundToJSON(json: any): PostFleetsFleetIdMembersNotFound {
    return PostFleetsFleetIdMembersNotFoundToJSONTyped(json, false);
}

export function PostFleetsFleetIdMembersNotFoundToJSONTyped(value?: PostFleetsFleetIdMembersNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

